import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { UserProfileStore } from '../stores/userProfileStore';

export const useUserProfileStore = () => useContext<{
  userProfileStore: UserProfileStore
}>(StoreContext);